/**
 * Check if the current page is in French.
 *
 * @returns True if the page is in French, false otherwise.
 */
export function isFrench(): boolean {
	return document.querySelector('html[lang="fr-CA"]') !== null;
}

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		isFrench: typeof isFrench;
	}
}

window.isFrench = isFrench;
